import { c as _c } from "react/compiler-runtime";
// hooks/useGlobalDisclosure.ts
import { isChewyBalanceOpenAtom, openChewyBalanceAtom, closeChewyBalanceAtom, toggleChewyBalanceAtom } from "@/config/atoms/modals/chewyBalance";
import { setSelectedTabAtom } from "@/config/atoms/portfolio/portfolioOpen";
import { useAtom } from "jotai";
export const useChewyBalanceOpen = () => {
  const $ = _c(6);
  const [isOpen, setIsOpen] = useAtom(isChewyBalanceOpenAtom);
  const [, open] = useAtom(openChewyBalanceAtom);
  const [, close] = useAtom(closeChewyBalanceAtom);
  const [, toggle] = useAtom(toggleChewyBalanceAtom);
  let t0;
  if ($[0] !== close || $[1] !== isOpen || $[2] !== open || $[3] !== setIsOpen || $[4] !== toggle) {
    t0 = {
      isOpen,
      onOpen: open,
      onClose: close,
      onOpenChange: toggle,
      setIsOpen
    };
    $[0] = close;
    $[1] = isOpen;
    $[2] = open;
    $[3] = setIsOpen;
    $[4] = toggle;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};